import { nanoid } from 'nanoid';
import React, { memo, useCallback, useEffect, useMemo } from 'react';
import { useBoolean } from '@sravni/react-utils';
import { Pixel } from '../Pixel/index.js';

const generateHolder = ({ urlHolderTag = 'div', children, href, className }) => {
    const isAnchor = urlHolderTag === 'a';
    const Tag = (isAnchor ? 'div' : urlHolderTag);
    const onClick = () => {
        window.open(href, '_blank', 'noreferrer');
    };
    return (React.createElement(Tag, { onClick: onClick, className: className }, children));
};
const generateAdditionalField = (structure) => {
    const { tag: Tag, class: tagClassName, value, children } = structure;
    return (React.createElement(Tag, { className: tagClassName },
        value,
        children?.map((child, index) => (
        // eslint-disable-next-line react/no-array-index-key
        React.createElement(React.Fragment, { key: index }, generateAdditionalField(child))))));
};
const MobileBottomWrapper = memo(({ bannerInfo, setBannerShown, onClick }) => {
    const [isBannerVisible, setBannerVisible] = useBoolean(true);
    const [isCloseButtonVisible, setCloseButtonVisible] = useBoolean(true);
    const handleClickCloseButton = useCallback((e) => {
        e?.preventDefault();
        e?.stopPropagation();
        setBannerVisible.off();
        setBannerShown();
    }, [setBannerShown, setBannerVisible]);
    const { pixels, containerClass, needCloseBtn: isNeedCloseButton, styles, url, urlHolderClass, urlHolderTag, timer, label, labelClass, additionalField: additionalFieldStructure, } = bannerInfo;
    useEffect(() => {
        const timerId = setTimeout(() => {
            setCloseButtonVisible.on();
        }, timer ?? 0);
        return () => {
            clearTimeout(timerId);
        };
    }, [setCloseButtonVisible, timer]);
    const HolderElement = useMemo(() => generateHolder({
        urlHolderTag,
        children: (React.createElement(React.Fragment, null,
            isNeedCloseButton && isCloseButtonVisible && (React.createElement("div", { className: "btn-close", onClick: handleClickCloseButton })),
            label !== undefined && React.createElement("div", { className: labelClass }, label),
            additionalFieldStructure !== undefined && generateAdditionalField(additionalFieldStructure))),
        className: urlHolderClass,
        href: url,
    }), [
        urlHolderTag,
        isNeedCloseButton,
        isCloseButtonVisible,
        handleClickCloseButton,
        labelClass,
        label,
        additionalFieldStructure,
        urlHolderClass,
        url,
    ]);
    return (React.createElement("div", { className: containerClass, "data-js": "mobileBottomBanner", onClick: onClick },
        pixels?.map((pixel) => (React.createElement(Pixel, { pixels: pixel, key: `pixel-${pixel}-${nanoid()}` }))),
        React.createElement("style", null, styles),
        isBannerVisible && HolderElement));
});

export { MobileBottomWrapper };
//# sourceMappingURL=index.js.map
